import { TFunction } from 'i18next';
import { PeriodGroupByEnum } from 'graphql-common';

// The backend only exposes DAY / WEEK / MONTH / YEAR. QUARTER is a UI-only
// granularity: the trend query is sent with MONTH and the FE aggregates three
// consecutive monthly buckets into a single quarter bucket (see fillTrendGaps).
export const TREND_QUARTER = 'QUARTER' as const;

export type TrendGroupBy = PeriodGroupByEnum | typeof TREND_QUARTER;

export interface TrendGroupByOption {
  value: TrendGroupBy;
  label: string;
}

/** Returns the ordered list of group-by options shown in the granularity select. */
export default function getTrendGroupByOptions(
  t: TFunction<'translation', undefined>,
): TrendGroupByOption[] {
  return [
    { value: PeriodGroupByEnum.Day, label: t('days') },
    { value: PeriodGroupByEnum.Week, label: t('weeks') },
    { value: PeriodGroupByEnum.Month, label: t('months') },
    { value: TREND_QUARTER, label: t('quarters') },
    { value: PeriodGroupByEnum.Year, label: t('years') },
  ];
}

/**
 * Maps a UI granularity value to the granularity accepted by the backend.
 * QUARTER has no native backend equivalent — we request MONTH and aggregate
 * on the frontend.
 */
export function toBackendPeriodGroupBy(
  groupBy: TrendGroupBy,
): PeriodGroupByEnum {
  return groupBy === TREND_QUARTER ? PeriodGroupByEnum.Month : groupBy;
}
